const { createContext, useContext } = require('react');

export const VARIANTS = { small: 'small', large: 'large' };

export const RedeemCouponContext = createContext({ variant: VARIANTS.large, halfWidth: false });

export const RedeemCouponProvider = RedeemCouponContext.Provider;

export const useRedeemCouponContext = () => useContext(RedeemCouponContext);
